import { z } from 'zod';
import { PHONE_MIN_LENGTH, PHONE_MAX_LENGTH } from '../../../constant/phone';

export const editUserOnboardingSchema = z.object({
  fullName: z.string().min(1, { message: 'Full name is required' }),
  email: z
    .string()
    .min(1, { message: 'Email is required' })
    .email({ message: 'Invalid email format' }),
  countryCode: z.string().optional().nullable(),
  phoneNumber: z
    .string()
    .optional()
    .nullable()
    .refine(
      (value) => !value || new RegExp(`^\\d{${PHONE_MIN_LENGTH},${PHONE_MAX_LENGTH}}$`).test(value),
      { message: `Phone Number must be between ${PHONE_MIN_LENGTH} and ${PHONE_MAX_LENGTH} digits` }
    ),
  countryId: z.string().optional().nullable(),
  administrativeRegionId: z.string().optional().nullable(),
  administrativeUnitId: z.string().optional().nullable(),
  lastMileUnitId: z.string().optional().nullable(),
  pincode: z.string().optional().nullable(),
  persona: z.string().optional().nullable(),
});
